var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcMlp40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_120)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#101233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0792 10.3792L12.004 10.9728L15.408 5.76959L16.0792 10.3792Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8256 36.1088L17.7752 36.4072L8.82321 17.7808L9.22401 17.168L16.9048 16.0496L19.8256 36.1088Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5592 8.99839L21.484 9.59199L20.8 4.89679L25.5592 8.99839Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4896 14.8032L26.9304 35.0744L25.2304 35.3224L22.3096 15.2624L29.7608 14.1768L30.4896 14.8032Z",
    fill: "#CAFFCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3224 12.8824L29.8424 9.58797L20.4688 10.9528L19.3976 3.59277L16.3672 4.03357L17.4392 11.3944L8.06561 12.7592L8.54561 16.0536L17.9192 14.6888L21.0136 35.936L24.0432 35.4944L20.9488 14.2472L30.3224 12.8824Z",
    fill: "#03F5AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_120"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMlp40);
export default __webpack_public_path__ + "static/media/ic_mlp_40.92637cb611664b73e576c9956c20cd07.svg";
export { ForwardRef as ReactComponent };